import IntlMessages from '@crema/utility/IntlMessages'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import LinearProgress from '@material-ui/core/LinearProgress'
import Paper from '@material-ui/core/Paper'
import RedButton from 'components/Button/RedButton'
import EnhancedTableToolbar from 'components/Table/EnhancedTableToolbar'
import OfferingTable from 'components/Temple/OfferingTable'
import usePermissionCheck from 'hooks/usePermissionCheck'
import React, { MouseEventHandler, useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import { apiStatus } from 'shared/constants/AppEnum'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { offeringDeleteThunk, offeringListThunk, selectCurrentTempleOfferings, selectOfferingStatus } from 'store/reducers/temple/offeringSlice'
import { IOfferingResponse } from 'types/api/temple'
import { PERMISSIONS, RESTRICTED_PATHS } from 'utils/permissions'
import OfferingToolbar, { OfferingFilterForm } from './OfferingToolbar'
import { offeringCategoryListThunk, selectCurrentTempleOfferingCategories } from 'store/reducers/temple/offeringCategorySlice'
import InfoView from '@crema/core/InfoView'
import EditOfferingDialog from './EditOfferingDialog'
import OfferingTimeManagerDialog from './OfferingTimeManagerDialog'
import BulkOfferingMediumDialog from './BulkOfferingMediumDialog'
import BulkOfferingPoolDialog from './BulkOfferingPoolDialog'
import BulkOfferingAddonFieldDialog from './BulkOfferingAddonFieldDialog'
import BulkOfferingCourierDialog from './BulkOfferingCourierDialog'
import BulkOfferingTagDialog from './BulkOfferingTagDialog'
import BulkOfferingTypeDatesDialog from './BulkOfferingTypeDatesDialog'
import { exportOfferingsToPDF } from 'utils/temple/pdfExport'
import { selectDeityAsMapWithUrl } from 'store/reducers/temple/deitySlice'
import { selectOfferingCategoryAsMapWithUrl } from 'store/reducers/temple/offeringCategorySlice'


const ListOffering: React.FC<RouteComponentProps> = ({ history, location }) => {
    const dispatch = useAppDispatch()
    const [deleteItem, setDeleteItem] = useState<IOfferingResponse | null>(null)
    const [dialogOpen, setDialogOpen] = useState(false)
    const [deleteIds, setDeleteIds] = useState<(string | number)[]>([])
    const { pathname } = location
    const offerings = useAppSelector(selectCurrentTempleOfferings)
    const offeringCategories = useAppSelector(selectCurrentTempleOfferingCategories)
    const categoryMap = useAppSelector(selectOfferingCategoryAsMapWithUrl)
    const deityMap = useAppSelector(selectDeityAsMapWithUrl)
    const api = useAppSelector(selectOfferingStatus)
    const permissions = usePermissionCheck(RESTRICTED_PATHS.OFFERINGS)
    const filters_ = location.search ? new URLSearchParams(location.search) : undefined
    const [filters, setFilters] = useState<OfferingFilterForm>({ category: filters_?.get('category') ?? '', deity: filters_?.get('deity') ?? '' })
    const [editOfferingStatus, setEditOfferingStatus] = useState<{ open: boolean, id?: string, }>({ open: false })
    const [selectedOfferingIds, setSelectedOfferingIds] = useState<(string | number)[]>([])
    const [bulkTimesOpen, setBulkTimesOpen] = useState(false)
    const [bulkMediumOpen, setBulkMediumOpen] = useState(false)
    const [bulkPoolsOpen, setBulkPoolsOpen] = useState(false)
    const [bulkAddonOpen, setBulkAddonOpen] = useState(false)
    const [bulkCourierOpen, setBulkCourierOpen] = useState(false)
    const [bulkTagOpen, setBulkTagOpen] = useState(false)
    const [bulkTypeDatesOpen, setBulkTypeDatesOpen] = useState(false)

    useEffect(() => {
        dispatch(offeringListThunk({}))
    }, [dispatch])

    useEffect(() => {
        if (offeringCategories.length === 0) {
            dispatch(offeringCategoryListThunk({}))
        }
    }, [dispatch, offeringCategories.length])

    const addNewHandler: MouseEventHandler<HTMLButtonElement> = () => history.push(`${pathname}/add`)
    const editHandler = (id: string | number) => setEditOfferingStatus({ open: true, id: id?.toString() })
    const selectedOfferings = offerings.filter(offering => selectedOfferingIds.includes(offering.id))

    const handleSelectOne = (id: string | number, checked: boolean) => {
        setSelectedOfferingIds(prev => checked ? [...prev, id] : prev.filter(item => item !== id))
    }

    const handleSelectAllVisible = (ids: (string | number)[], checked: boolean) => {
        setSelectedOfferingIds(prev => {
            if (!checked) return prev.filter(id => !ids.includes(id))
            const next = [...prev]
            ids.forEach(id => {
                if (!next.includes(id)) next.push(id)
            })
            return next
        })
    }

    const handlerOpenDialog = (id: string | number) => {
        let item = offerings.find(o => o.id === id)
        if (item) {
            setDeleteItem(item)
            setDialogOpen(true)
        }
    }

    const handlerCloseDialog = (canDelete?: boolean) => {
        if (canDelete && deleteItem) {
            setDeleteIds([...deleteIds, deleteItem.id])
            dispatch(offeringDeleteThunk(deleteItem))
                .finally(() => {
                    setDeleteIds(deleteIds.filter(id => id !== deleteItem.id))
                    setDeleteItem(null)
                })
        }
        setDialogOpen(false)
    }

    const handleDownloadPdf = () => {
        exportOfferingsToPDF(offerings, categoryMap, deityMap)
    }

    return (
        <Box>
                <InfoView />
                <Paper style={{}}>
                    <OfferingToolbar values={filters} changeFilter={(values) => { setFilters(values) }} receiptApi={api} onDownloadPdf={handleDownloadPdf} />
                {/* <EnhancedTableToolbar
                    title={<IntlMessages id={'offering.title'} />}
                    showFilter={true}

                    addNew={permissions.includes(PERMISSIONS.ADD) ? { handle: addNewHandler } : undefined}
                /> */}
                {api.status === apiStatus.LOADING && <LinearProgress />}
                <OfferingTable filterList={filters}
                    editHandler={permissions.includes(PERMISSIONS.CHANGE) ? editHandler : undefined}
                    deleteHandler={permissions.includes(PERMISSIONS.DELETE) ? handlerOpenDialog : undefined}
                    deletingIds={permissions.includes(PERMISSIONS.DELETE) ? deleteIds : undefined}
                    offerings={offerings}
                    selectedIds={selectedOfferingIds}
                    onSelectOne={handleSelectOne}
                    onSelectAllVisible={handleSelectAllVisible}
                    onBulkEditTimes={permissions.includes(PERMISSIONS.CHANGE) ? () => setBulkTimesOpen(true) : undefined}
                    onBulkEditMedium={permissions.includes(PERMISSIONS.CHANGE) ? () => setBulkMediumOpen(true) : undefined}
                    onBulkEditPools={permissions.includes(PERMISSIONS.CHANGE) ? () => setBulkPoolsOpen(true) : undefined}
                    onBulkEditAddonFields={permissions.includes(PERMISSIONS.CHANGE) ? () => setBulkAddonOpen(true) : undefined}
                    onBulkEditCourier={permissions.includes(PERMISSIONS.CHANGE) ? () => setBulkCourierOpen(true) : undefined}
                    onBulkEditTags={permissions.includes(PERMISSIONS.CHANGE) ? () => setBulkTagOpen(true) : undefined}
                    onBulkEditTypeDates={permissions.includes(PERMISSIONS.CHANGE) ? () => setBulkTypeDatesOpen(true) : undefined}
                />
            </Paper>
            <Dialog open={Boolean(dialogOpen && deleteItem)}>
                <DialogTitle>{`Are you sure you want to delete ${deleteItem?.name}?`}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Warning: You cannot reverse this action!
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="primary" onClick={() => handlerCloseDialog(false)}>
                        <IntlMessages id="common.cancel" />
                    </Button>
                    <RedButton variant="outlined" onClick={() => handlerCloseDialog(true)} autoFocus>
                        <IntlMessages id="common.delete" />
                    </RedButton>
                </DialogActions>
            </Dialog>
            {editOfferingStatus.id && <EditOfferingDialog open={editOfferingStatus.open} id={editOfferingStatus.id} handleClose={() => { setEditOfferingStatus({ open: false }) }} />}
            <OfferingTimeManagerDialog
                open={bulkTimesOpen}
                mode="bulk"
                offerings={selectedOfferings}
                onClose={() => setBulkTimesOpen(false)}
                onComplete={() => setSelectedOfferingIds([])}
            />
            <BulkOfferingMediumDialog
                open={bulkMediumOpen}
                offerings={selectedOfferings}
                onClose={() => setBulkMediumOpen(false)}
                onComplete={() => setSelectedOfferingIds([])}
            />
            <BulkOfferingPoolDialog
                open={bulkPoolsOpen}
                offerings={selectedOfferings}
                onClose={() => setBulkPoolsOpen(false)}
                onComplete={() => setSelectedOfferingIds([])}
            />
            <BulkOfferingAddonFieldDialog
                open={bulkAddonOpen}
                offerings={selectedOfferings}
                onClose={() => setBulkAddonOpen(false)}
                onComplete={() => setSelectedOfferingIds([])}
            />
            <BulkOfferingCourierDialog
                open={bulkCourierOpen}
                offerings={selectedOfferings}
                onClose={() => setBulkCourierOpen(false)}
                onComplete={() => setSelectedOfferingIds([])}
            />
            <BulkOfferingTagDialog
                open={bulkTagOpen}
                offerings={selectedOfferings}
                onClose={() => setBulkTagOpen(false)}
                onComplete={() => setSelectedOfferingIds([])}
            />
            <BulkOfferingTypeDatesDialog
                open={bulkTypeDatesOpen}
                offerings={selectedOfferings}
                onClose={() => setBulkTypeDatesOpen(false)}
                onComplete={() => setSelectedOfferingIds([])}
            />
        </Box>
    );
}


export default ListOffering
